'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
exports.renderViewDefault = renderViewDefault;
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/* eslint-disable react/prop-types */

function renderViewDefault(props) {
  return _react2["default"].createElement('div', props);
}
function renderTrackHorizontalDefault(_ref) {
  var style = _ref.style,
    props = _objectWithoutProperties(_ref, ['style']);
  var finalStyle = _extends({}, style, {
    right: 2,
    bottom: 2,
    left: 2,
    borderRadius: 3
  });
  return _react2["default"].createElement('div', _extends({
    style: finalStyle
  }, props));
}
function renderTrackVerticalDefault(_ref2) {
  var style = _ref2.style,
    props = _objectWithoutProperties(_ref2, ['style']);
  var finalStyle = _extends({}, style, {
    right: 2,
    bottom: 2,
    top: 2,
    borderRadius: 3
  });
  return _react2["default"].createElement('div', _extends({
    style: finalStyle
  }, props));
}
function renderThumbHorizontalDefault(_ref3) {
  var style = _ref3.style,
    props = _objectWithoutProperties(_ref3, ['style']);
  var finalStyle = _extends({}, style, {
    cursor: 'pointer',
    borderRadius: 'inherit',
    backgroundColor: 'rgba(0,0,0,.2)'
  });
  return _react2["default"].createElement('div', _extends({
    style: finalStyle
  }, props));
}
function renderThumbVerticalDefault(_ref4) {
  var style = _ref4.style,
    props = _objectWithoutProperties(_ref4, ['style']);
  var finalStyle = _extends({}, style, {
    cursor: 'pointer',
    borderRadius: 'inherit',
    backgroundColor: 'rgba(0,0,0,.2)'
  });
  return _react2["default"].createElement('div', _extends({
    style: finalStyle
  }, props));
}